/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/employee'

const employeeEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) => ({
  fetchEmployees: builder.query<any, any>({
    query: (params) => ({
      url: `${basePath}`,
      params,
    }),
    providesTags: ['employees']
  }),

  fetchEmployeeById: builder.query<any, string>({
    query: (id) => `${basePath}/${id}`,
    providesTags: ['employees']
  }),

  createEmployee: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}`,
      method: 'POST',
      body,
      formData: true,
    }),
    invalidatesTags: ['employees']
  }),

  updateEmployee: builder.mutation<any, { id: string; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'PUT',
      body,
      formData: true,
    }),
    invalidatesTags: ['employees']
  }),

  deleteEmployee: builder.mutation<any, string>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['employees']
  }),
})

export default employeeEndpoints
